export default "__VITE_ASSET__ddc4946e__"